module.exports = __webpack_public_path__ + "static/img/Abdominal_organs.85ac44e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/organs/Abdominal_organs.png
// module id = wNi7
// module chunks = 1